// Product and Cart page product quantities actions
$(function () {
  // Quantity selector on product and cart pages
  increaseProductQty();
  decreaseProductQty();

  setTimeout(function () {
    updateProductQtys();
  }, 100);

  jQuery(document.body).on('updated_cart_totals', function () {
    updateProductQtys();
    increaseProductQty();
    decreaseProductQty();
  });

  function updateProductQtys() {
    const qtyInputs = document.querySelectorAll('.qty-input');
    for (let index = 0; index < qtyInputs.length; index++) {
      var maxValue = qtyInputs[index].getAttribute('max');
      var valueValue = qtyInputs[index].value;

      if (!maxValue) {
        maxValue = 999;
      }

      if (maxValue === valueValue) {
        qtyInputs[index].parentElement
          .querySelector('.increase-number')
          .classList.add('disabled');
      }
      if (valueValue == 1) {
        // qtyInputs[index].parentElement.querySelector('.decrease-number').classList.add('disabled');
      }
      if (valueValue > 0 && maxValue > 1) {
        qtyInputs[index].parentElement
          .querySelector('.increase-number')
          .classList.remove('disabled');
      }

      if (maxValue != valueValue) {
        qtyInputs[index].parentElement
          .querySelector('.decrease-number')
          .classList.remove('disabled');
      }
    }
  }

  function increaseProductQty() {
    const increaseNumber = document.querySelectorAll('.increase-number');
    for (let index = 0; index < increaseNumber.length; index++) {
      increaseNumber[index].addEventListener('click', function () {
        let qtyInput = this.parentElement.querySelector('.qty-input');
        let currentVal = parseFloat(qtyInput.value);

        let thisDecrease = this.parentElement.querySelector('.decrease-number');
        let maxValue = qtyInput.getAttribute('max');
        if (!maxValue) {
          maxValue = 999;
        }

        if (document.querySelectorAll('[name="update_cart"]').length > 0) {
          document.querySelector('[name="update_cart"]').disabled = false;
        }

        if (maxValue > parseFloat(qtyInput.value)) {
          if (!isNaN(currentVal)) {
            const newVal = currentVal + 1;
            qtyInput.value = newVal;
          }
        }

        if (maxValue === qtyInput.value) {
          this.classList.add('disabled');
        }

        if (qtyInput.value > 1) {
          thisDecrease.classList.remove('disabled');
        }

        if (
          document.querySelectorAll(
            'body.woocommerce-cart button[name="update_cart"]'
          ).length > 0
        ) {
          document
            .querySelector('body.woocommerce-cart button[name="update_cart"]')
            .click();
        }
      });
    }
  }

  function decreaseProductQty() {
    const decreaseNumber = document.querySelectorAll('.decrease-number');
    for (let index = 0; index < decreaseNumber.length; index++) {
      decreaseNumber[index].addEventListener('click', function () {
        let qtyInput = this.parentElement.querySelector('.qty-input');

        let thisIncrease = this.parentElement.querySelector('.increase-number');

        if (document.querySelectorAll('[name="update_cart"]').length > 0) {
          document.querySelector('[name="update_cart"]').disabled = false;
        }
        let maxValue = qtyInput.getAttribute('max');

        var currentVal = parseFloat(qtyInput.value);
        if (!isNaN(currentVal) && currentVal > 1) {
          qtyInput.value = currentVal - 1;
        }

        if (maxValue > parseFloat(qtyInput.value)) {
          thisIncrease.classList.remove('disabled');
        }

        if (parseFloat(qtyInput.value) == maxValue) {
          this.classList.remove('disabled');
        }
        if (
          document.querySelectorAll(
            'body.woocommerce-cart button[name="update_cart"]'
          ).length > 0
        ) {
          document
            .querySelector('body.woocommerce-cart button[name="update_cart"]')
            .click();
        }
      });
    }
  }

  // AJAX product add to cart button
  /* eslint-disable */
  if (jQuery('form.cart').length > 0) {
    $('form.cart').on('submit', function (e) {
      e.preventDefault();

      var form = $(this);
      form.block({
        message: null,
        overlayCSS: { background: '#fff', opacity: 0.6 },
      });

      var formData = new FormData(form[0]);

      if (form.hasClass('variations_form')) {
        form
          .find('[name=add-to-cart]')
          .val(form.find('[name=variation_id]').val());
        form
          .find('[name=product_id]')
          .val(form.find('[name=variation_id]').val());
      }

      formData.append('add-to-cart', form.find('[name=add-to-cart]').val());

      // Ajax action.
      $.ajax({
        url: wc_add_to_cart_params.wc_ajax_url
          .toString()
          .replace('%%endpoint%%', 'add_to_cart'),
        data: formData,
        type: 'POST',
        processData: false,
        contentType: false,
        complete: function (response) {
          response = response.responseJSON;

          if (!response) {
            return;
          }

          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }

          // Redirect to cart option
          if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
            window.location = wc_add_to_cart_params.cart_url;
            return;
          }

          // Refresh cart counter
          $.ajax({
            url: wc_add_to_cart_params.wc_ajax_url
              .toString()
              .replace('%%endpoint%%', 'cart_count_refresh'),
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
            complete: function (response) {
              if (!response.responseText) {
                return;
              }
              jQuery('.cart-result').text(response.responseText);
            },
          });

          var addedPopup = $('.js-added-to-cart');
          addedPopup.addClass('active');
          setTimeout(function () {
            addedPopup.removeClass('active');
          }, 3000);

          var $thisbutton = form.find('.single_add_to_cart_button'); //

          // Trigger event so themes can refresh other areas.
          $(document.body).trigger('added_to_cart', [
            response.fragments,
            response.cart_hash,
            $thisbutton,
          ]);

          // Remove existing notices
          $(
            '.woocommerce-error, .woocommerce-message, .woocommerce-info'
          ).remove();

          // Add new notices
          form.closest('.product').before(response.fragments.notices_html);

          form.unblock();
        },
      });
    });
  }
  /* eslint-enable */

  // Generates variation select as radio buttons (desktop) or select2() instance (mobile)
  jQuery(document).ready(function ($) {
    if (window.innerWidth <= 768) {
      // Generates custom select box with variation values
      if (
        jQuery('.woocommerce div.product form.cart .variations select').length >
        0
      ) {
        jQuery('.woocommerce div.product form.cart .variations select').select2(
          {
            minimumResultsForSearch: -1,
          }
        );
      }
    }

    $('.variations_form').on(
      'wc_variation_form woocommerce_update_variation_values',
      function () {
        $('label.generatedRadios').remove();
        $('table.variations select').each(function () {
          var selName = $(this).attr('name');
          $('select[name=' + selName + '] option')
            .each(function () {
              var option = $(this);
              var value = option.attr('value');
              var attrDescription = option.attr('data-description');
              if (value == '') {
                return;
              }
              var label = option.html();
              var select = option.parent();
              var selected = select.val();
              var selClass = selected == value ? ' selected' : '';
              var inputHtml = `<input name="${selName}" type="radio" value="${value}" />`;
              var optionHtml = `<label class="generatedRadios${selClass}">${inputHtml} ${label}</label>`;

              setTimeout(function () {
                var selProductId = $('[name="variation_id"]').val();
                $('[name="add-to-cart"]').val(selProductId);
                $('[name="product_id"]').val(selProductId);

                // If only one atribute rendered, simulates click to show attribute description
                if (
                  document.querySelectorAll(
                    'body.single-product div.product form.cart .variations label.generatedRadios'
                  ).length == 1
                ) {
                  document
                    .querySelector(
                      'body.single-product div.product form.cart .variations label.generatedRadios'
                    )
                    .click();
                }
              }, 10);

              // generate radio buttons only for desktop
              if (window.innerWidth > 768) {
                select.parent().append(
                  $(optionHtml).click(function () {
                    if (
                      document.querySelectorAll(
                        '.variations label.generatedRadios'
                      ).length > 1
                    ) {
                      select.val(value).trigger('change');
                    }
                    jQuery('.attribute-description').text(attrDescription);
                  })
                );
              }
            })
            .parent()
            .hide();
        });
      }
    );
  });

  // Shows selected product variation price instead general price range on product variations page
  jQuery(function ($) {
    if (document.querySelectorAll('body.single-product').length > 0) {
      let price = document.querySelector('p.price');
      let price_html = price.innerHTML;

      jQuery('form.cart')
        .on('show_variation', function (event, data) {
          if (data.is_in_stock) {
            if (data.price_html) {
              price.innerHTML = data.price_html;
            }
          } else {
            price.innerHTML = data.availability_html;
          }

          // For future use ->
          // if ( data.backorders_allowed ) {
          //   price.innerHTML = 'Galima užsakyti';
          // }
        })
        .on('hide_variation', function () {
          price.innerHTML = price_html;
        });
    }
  });
});
